// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1_EAg{background-color:#fff;border-radius:.5rem;-webkit-box-shadow:0 8px 16px 0 rgba(159,160,160,.2);box-shadow:0 8px 16px 0 rgba(159,160,160,.2);padding-bottom:.75rem}._1_EAg+._1_EAg{margin-top:1rem}._2QYY4{padding:1.5rem;border-bottom:1px solid #dcdddd;font-size:18px;font-size:1.125rem;font-weight:500;line-height:25px;line-height:1.5625rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}", ""]);
// Exports
exports.locals = {
	"root": "_1_EAg",
	"title": "_2QYY4"
};
module.exports = exports;
